// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"873":"5a334edb","895":"225c341e"}[chunkId] + ".chunk.js";
};